/* --- App --- */
var md = new MobileDetect(window.navigator.userAgent);

var app = {
	isPlaying: false,
	contentReady: false,
	isMobile: md.phone() ? true : false,
	isTablet: md.tablet() ? true : false,
	osVersion: md.version('Webkit'),
	isWebview: browserdata.webview,
	nav: {
		in: true,
		burgerOpen: false
	},
	sizes: {},
	plugins: {},
	router: {},
	state: {},
	loader: {},
	device: {},
	dom: {},
	utils: {},
	filters: {},
};

/* --- DOM --- */
app.dom = {
	$html: $('html'),
	$body: $('body'),
	$document: $(document),
	$window: $(window),
	$jaxContent: '#main',
	$scroll_wrapper: '.content-wrap',
	$masthead: '.mainnav',
};

app.loader = {
	linkType: null,
	disabled: false,
	heroSliderInterval: true,
	homeSliderAutoplay: true,
}

app.sizes = {
	viewporth: $(window).height(),
	realviewporth: window.innerHeight,
	viewportw: window.innerWidth
};
